import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/api';
import useAuth from '../hooks/useAuth';
import styles from './LoginPage.module.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // Nouvel état pour voir le mdp
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await api.post('/auth/login', { email, password });
      login(response.data.access_token);
      
      if (response.data.role === 'Admin') {
        navigate('/admin-dashboard');
      } else {
        navigate('/home');
      }

    } catch (err) {
      console.error(err);
      setError('Email ou mot de passe incorrect.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.pageContainer}>
      <div className={styles.card}>
        <div className={styles.header}>
          <h2 className={styles.title}>Bienvenue</h2>
          <p className={styles.subtitle}>Connectez-vous à l'espace AKM</p>
        </div>

        {error && (
          <div className={styles.error}>
            <span style={{ marginRight: '8px' }}>⚠️</span> {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {/* Champ Email */}
          <div className={styles.formGroup}>
            <label htmlFor="email" className={styles.label}>Adresse Email</label>
            <div className={styles.inputWrapper}>
              <span className={styles.inputIcon}>✉️</span>
              <input
                type="email"
                id="email"
                className={styles.input}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="exemple@akm.com"
                required
              />
            </div>
          </div>

          {/* Champ Mot de passe */}
          <div className={styles.formGroup}>
            <label htmlFor="password" className={styles.label}>Mot de passe</label>
            <div className={styles.inputWrapper}>
              <span className={styles.inputIcon}>🔒</span>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                className={styles.input}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
              <button 
                type="button" 
                className={styles.togglePassword}
                onClick={() => setShowPassword(!showPassword)}
                aria-label="Afficher le mot de passe"
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>

          <button type="submit" className={styles.submitBtn} disabled={isLoading}>
            {isLoading ? <span className={styles.loader}></span> : 'Se connecter'}
          </button>
        </form>
        
        <div className={styles.footer}>
          <p>Problème de connexion ? Contactez l'admin.</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;